@if (orderInfoFields?.length > 0) {
  <ng-container [formGroup]="form">
    @for (formControl of customFormControls; track trackByFn(index, formControl); let index = $index) {
      @if (index === 0 || index === 2 || index === 4) {
        <td colspan="3" class="table-col">
          <label class="c-form-group-inline form-group" [ngClass]="formControl.orderInfoFieldValue.orderInfoField.mandatory ? 'required' : 'optional'">
            <span class="label-content bold">{{
              formControl.shopText
            }}</span>
            @if (readonly) {
              <span class="label-value">
                {{ formControl.orderInfoFieldValue.value }}
              </span>
            }
            @if (!readonly && formControl.key) {
              <div class="text-left">
                <div class="input-block">
                  <input class="form-control mr-2" type="{{formControl.inputType}}" placeholder="{{formControl.placeholderText}}" formControlName="{{formControl.key}}"
                    [maxLength]="formControl.inputType === 'text' ? formControl.orderInfoFieldValue.orderInfoField.length : ''"
                    (change)="orderEntryFieldsChange($event, formControl.orderInfoFieldValue.orderInfoField, form.get(formControl.key))" [disableTooltip]="formControl.toolTipText.length === 0" ngbTooltip="{{formControl.toolTipText}}" placement="top"/>
                    @if ((cartEntryInfosUpdating$| async) && (currentCartEntryNumberUpdating$ | async) === entryNumber && (currentCartEntryOrderInfoFieldIdUpdating$| async) === formControl.orderInfoFieldValue.orderInfoField.fieldId && (currentCartEntryInfoTypeUpdating$ | async) === 'orderInfoFields') {
                      <cx-icon
                      type="SPINNER"></cx-icon>
                    }
                  </div>
                  <cx-form-errors [control]="form.get(formControl.key)"></cx-form-errors>
                </div>
              }
            </label>
          </td>
        } @else {
          <td colspan="5" class="table-col">
            <label class="c-form-group-inline form-group" [ngClass]="formControl.orderInfoFieldValue.orderInfoField.mandatory ? 'required' : 'optional'">
              <span class="label-content bold">{{
                formControl.shopText
              }}</span>
              @if (readonly) {
                <span class="label-value">
                  {{ formControl.orderInfoFieldValue.value }}
                </span>
              }
              @if (!readonly && formControl.key) {
                <div class="text-left">
                  <div class="input-block">
                    <input class="form-control mr-2" type="{{formControl.inputType}}" placeholder="{{formControl.placeholderText}}" formControlName="{{formControl.key}}"
                      [maxLength]="formControl.inputType === 'text' ? formControl.orderInfoFieldValue.orderInfoField.length : ''"
                      (change)="orderEntryFieldsChange($event, formControl.orderInfoFieldValue.orderInfoField, form.get(formControl.key))" [disableTooltip]="formControl.toolTipText.length === 0" ngbTooltip="{{formControl.toolTipText}}" placement="top"/>
                      @if ((cartEntryInfosUpdating$| async) && (currentCartEntryNumberUpdating$ | async) === entryNumber && (currentCartEntryOrderInfoFieldIdUpdating$| async) === formControl.orderInfoFieldValue.orderInfoField.fieldId && (currentCartEntryInfoTypeUpdating$ | async) === 'orderInfoFields') {
                        <cx-icon
                        type="SPINNER"></cx-icon>
                      }
                    </div>
                    <cx-form-errors [control]="form.get(formControl.key)"></cx-form-errors>
                  </div>
                }
              </label>
            </td>
          }
        }
      </ng-container>
    }
